module.exports = __webpack_public_path__ + "img/kboard.19d3d248.svg";